import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors, spacing }: Theme) => createStyles({
  root: {
    padding: `${spacing(1)}px 0 ${spacing(1)}px 0}`,
    background: colors.dropmenuBackground,
    minWidth: spacing(35),
    maxWidth: spacing(50),
    display: 'grid',
    gap: `${spacing(1)}px`,
  },
});

export default styles;
